<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <b-container>
    <b-modal ref="my-modal" v-model="stateDetailVisible" ok-title="关闭" ok-only title="详情">
      <p v-for="item in stateDetailSelect">
        <span style="margin-right:20px">{{item.time}}</span>
        <b-badge variant="primary" v-if="item.sts == 0">提交审核</b-badge>
        <b-badge variant="danger" v-if="item.sts == 1">审核不通过</b-badge>
        <b-badge variant="secondary" v-if="item.sts == 2">审核通过</b-badge>
        <b-badge variant="primary" v-if="item.sts == 3">再次提交审核</b-badge>
      </p>
    </b-modal>

    <b-modal id="my-modal">上传成功</b-modal>

    <b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>

    <b-modal
      ref="my-modal2"
      v-model="reupload"
      @close="reuploadClose"
      @ok="reuploadClose"
      no-close-on-backdrop
      no-close-on-esc
      ok-title="关闭"
      ok-only
      title="重新上传"
    >
      <b-form-group style="background-color:#d1ecf1;padding:20px" id="input-group-3" label-for="input-3">
        <b-badge variant="secondary">只允许上传pdf文件，大小10M以内</b-badge>
        <b-form-file
          v-model="file2"
          plain
          accept=".pdf"
          style="margin-top:10px"
          @input="uploadImgChange"
          :disabled="expired"
        ></b-form-file>
        <b-button
          size="sm"
          variant="outline-primary"
          style="margin-top:10px"
          @click="startUpload(2)"
          :disabled="expired"
        >开始上传</b-button>
        <!-- <b-progress class="mt-2" :max="100" show-value>
        <b-progress-bar :value="uploadProgress" variant="success"></b-progress-bar>
        </b-progress>-->
      </b-form-group>
    </b-modal>

    <b-alert show variant="info" class="mt20">
      <h4 class="alert-heading">重大科学技术问题研究科学考察项目需求建议</h4>
      <div v-html="promptMsg2"></div>
      <hr />
      <p v-html="promptMsg"></p>
      <a
        style="font-size:18px;font-weight:bold"
        href="/template/共享航次计划重大科学技术问题研究科学考察项目需求建议表.doc"
      >共享航次计划重大科学技术问题研究科学考察项目需求建议表</a>
    </b-alert>

    <b-form-group style="background-color:#d1ecf1;padding:20px" id="input-group-3" label-for="input-3">
      <b-badge variant="secondary">只允许上传pdf文件，大小10M以内</b-badge>
      <b-form-file
        v-model="file2"
        plain
        accept=".pdf"
        style="margin-top:10px"
        @input="uploadImgChange"
        :disabled="expired"
      ></b-form-file>
      <b-button
        size="sm"
        variant="outline-primary"
        style="margin-top:10px"
        @click="startUpload(1)"
        :disabled="expired"
      >开始上传</b-button>
      <!-- <b-progress class="mt-2" :max="100" show-value>
        <b-progress-bar :value="uploadProgress" variant="success"></b-progress-bar>
      </b-progress>-->
    </b-form-group>

    <b-row class="mt20">
      <b-col lg="4" xl="4" sm="12" md="4">
        <h5 class="alert-heading">您的提交记录</h5>
      </b-col>

      <b-col lg="2" xl="2" sm="3" md="2">
        <b-form-select v-if="false" v-model="selectedTheme" :options="tableTheme" placeholder="请选择表主题"></b-form-select>
      </b-col>

      <b-col lg="2" xl="2" sm="3" md="2"></b-col>

      <b-col lg="4" xl="4" sm="6" md="4"></b-col>
    </b-row>

    <b-spinner variant="primary" label="Spinning" v-if="loading"></b-spinner>

    <h3 v-if="!loading && items.length == 0">未查到相关记录</h3>

    <b-table
      class="mt10"
      bordered
      style="text-align: left"
      responsive
      striped
      hover
      :items="items"
      :fields="fields"
      :dark="selectedTheme == 2"
      v-if="items.length > 0"
    >
      <template v-slot:cell(status)="data">
        <b-badge v-if="data.item.status == 0" variant="primary">审核中</b-badge>
        <b-badge v-if="data.item.status == 1" variant="danger">审核不通过</b-badge>
        <b-badge v-if="data.item.status == 2" variant="secondary">已审核</b-badge>
        <b-badge v-if="data.item.status == 3" variant="primary">再次审核中</b-badge>
      </template>

      <template v-slot:cell(fileName)="data">
        <a :href="data.item.fileName2" target="_blank">{{data.item.fileName}}</a>
      </template>

      <template v-slot:cell(operate)="data">
        <div style="width:150px">
          <b-button @click="modify(data.item)" class="opButton" size="sm" variant="outline-primary" :disabled="expired">重新提交</b-button>
          <b-button @click="showStateDetail(data)" class="opButton" size="sm" variant="outline-primary">状态详情</b-button>
          <b-button @click="applyPdf(data.item)" class="opButton" size="sm" variant="outline-primary">下载PDF</b-button>
        </div>
      </template>
    </b-table>

    <b-pagination
      v-if="items.length > 0"
      align="center"
      class="mt20"
      :number-of-pages="pagination.totalPage"
      :value="pagination.page"
      :total-rows="pagination.total"
      :per-page="reqBody.pageSize"
      base-url="#"
      first-text="首页"
      prev-text="上一页"
      next-text="下一页"
      last-text="末页"
      first-number
      last-number
      @change="pageChangeListener"
    ></b-pagination>

    <link-component></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import Vue from 'vue';
import { axiosServer } from '@/api/judge';
import { requestSoExplain } from '@/api/SvpConfig';
import axios from '@/api/axios';

export default {
  components: { LinkComponent },
  name: 'ChiefScientistExplain',
  props: {},
  computed: {},
  data() {
    return {
      uploadProgress: 0,
      reqBody: { page: 1, pageSize: 10, cruiseYear: null },
      years: [
        { value: null, text: '全部年份' },
        { value: '2025', text: '2025' },
        { value: '2024', text: '2024' },
        { value: '2023', text: '2023' },
        { value: '2022', text: '2022' },
        { value: '2021', text: '2021' },
        { value: '2020', text: '2020' },
        { value: '2019', text: '2019' },
        { value: '2018', text: '2018' },
        { value: '2017', text: '2017' },
        { value: '2016', text: '2016' },
        { value: '2015', text: '2015' },
      ],
      stateDetailSelect: [],
      stateDetailVisible: false,
      fields: [
        { key: 'id', label: '申请号' },
        { key: 'fileName', label: '申请书' },
        { key: 'createTime', label: '提交时间' },
        { key: 'status', label: '状态' },
        { key: 'operate', label: '操作' },
      ],
      bread: [
        {
          text: '首页',
          href: '/index',
        },
        {
          text: '科学问题需求建议',
        },
      ],
      promptMsg: '',
      promptMsg2: '',
      expired: true,
      items: [],
      pagination: {},
      loading: true,
      keyword: '',
      selectFile: null,
      file2: null,
      reupload: false,
      reuploadItem: {},
    };
  },
  activated() {
    this.checkLogin();
    requestSoExplain().then((resp) => {
      this.promptMsg2 = resp.description;
      this.promptMsg = resp.content;
      this.expired = resp.expired;
    });
    this.requestCsApplyList();
  },

  mounted() {
    this.checkLogin();
  },
  methods: {
    reuploadClose() {
      console.log('reupload close');
      this.reuploadItem = {};
    },
    modify(data) {
      this.reuploadItem = data;
      this.reupload = true;
    },
    uploadImgChange(file) {
      this.uploadProgress = 0;
      this.selectFile = file;
    },

    startUpload(index) {
      if (!this.selectFile) {
        return;
      }
      this.uploadToSever(this.selectFile, index);
    },

    uploadToSever(file) {
      let fileSizeK = file.size / 1024;
      if (fileSizeK > 1024 * 10) {
        this.promptVisible = true;
        return;
      }

      let param = new FormData(); // 创建form对象
      param.append('fileName', file); // 通过append向form对象添加数据
      param.append('chunk', '0'); // 添加form表单中其他数据

      let id = this.reuploadItem.id || 0;

      axios
        .post(process.env.NODE_ENV == 'development' ? '/proxyApi/SvpUpload/so?id=' + id : '/SvpUpload/so?id=' + id, param, {
          header: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            let complete = (((progressEvent.loaded / progressEvent.total) * 100) | 0) + '%';
            this.uploadProgress = complete;
          },
        })
        .then((resp) => {
          if (resp.data.code == 0) {
            this.$bvModal.show('my-modal');
            this.selectFile = null;
            this.file2 = null;
            this.$forceUpdate();
            this.requestCsApplyList();
          }
        });
    },

    applyPdf(item) {
      window.open('/so/' + item.fileName, '_blank');
    },
    showStateDetail(data) {
      this.stateDetailSelect = JSON.parse(data.item.statusTime);
      this.stateDetailVisible = true;
    },
    goDetail(code, data) {
      this.$router.push({ name: 'ChiefScientistForm', query: { code: code, applyId: data.applyId } });
    },
    requestCsApplyList(isSearchBtnClick) {
      if (isSearchBtnClick) {
        this.reqBody.page = 1;
        this.reqBody.cruiseName = this.keyword;
      }

      this.loading = true;
      axiosServer({
        url: '/SvpSoApply',
        params: this.reqBody,
      })
        .then((resp) => {
          this.loading = false;
          this.items = resp.data.page.list;
          let page = resp.data.page;

          page.list.forEach((data) => {
            data.fileName2 = '/so/' + data.fileName;
          });

          this.pagination = {
            page: page.page + 1,
            pageSize: page.pageSize,
            total: page.total,
            totalPage: page.totalPage,
          };
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    checkLogin() {
      let loginName = Vue.ls.get('token');
      if (!loginName) {
        this.$router.push({
          name: 'login',
          query: { tip: 1, msg: '访问搭载需求征集页面需要先登录', redirectUrl: 'ChiefScientistExplain' },
        });
      }
    },
    toForm() {
      this.$router.push({ name: 'ChiefScientistForm' });
    },
  },
};
</script>

<style scoped>
.opButton {
  padding: 2px;
  width: 65px;
  margin-left: 5px;
  margin-top: 5px;
}

.proj-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
  padding: 0px;
  margin-bottom: 0px;
}

/* 响应式布局：方案不同屏幕尺寸分别使用不同的CSS样式 */
@media (max-width: 575.99px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 576px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 768px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 50px;
  }
}

@media (min-width: 992px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 100px;
  }
}

@media (min-width: 1200px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 200px;
  }
}
</style>
